import clsx from 'clsx'

import { Box, Icon } from '@percent/lemonade'
import classes from './AchievementBadge.module.scss'

type Size = 'medium' | 'large'

type AchievementBadgeProps = {
  image: string
  name: string
  isBlocked?: boolean
  size?: Size
}

const sizeClassMap: Record<Size, string> = {
  medium: classes.Medium,
  large: classes.Large
}

const iconSizeMap = {
  medium: 5,
  large: 6
} as const

export function AchievementBadge({ image, name, isBlocked, size = 'medium' }: Readonly<AchievementBadgeProps>) {
  return (
    <Box className={clsx(classes.BadgeWrapper, sizeClassMap[size])}>
      <img src={image} alt={name} className={clsx({ [classes.BlockedImg]: isBlocked })} />
      {isBlocked ? (
        <Box className={classes.LockedBadgeCover}>
          <Icon name="lock-filled" color="black" size={iconSizeMap[size]} />
        </Box>
      ) : null}
    </Box>
  )
}
